import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import { Checkbox } from '../Checkbox'

const makeLabel = (label, searchString) => {
  return (
    <div>
      {searchString.length > 0
        ? label.split(searchString).map((c, i) => (
            <React.Fragment key={i}>
              {i > 0 && (
                <span className='e-select__tray__option__label'>
                  {searchString}
                </span>
              )}
              <span>{c}</span>
            </React.Fragment>
          ))
        : label}
    </div>
  )
}

export const SelectOption = ({
  option,
  optionIndex,
  onMouseEnter,
  onSelect,
  focus,
  withCheckbox,
  searchString,
  loading
}) => {
  //  const optionIndex = options.findIndex(({ value }) => value === option.value)
  const handleClick = e => {
    if (withCheckbox) {
      e.preventDefault()
      e.stopPropagation()
    }
    if (option.disabled) {
      return
    }
    onSelect(option)
  }

  return (
    <li
      tabIndex='0'
      onClick={!loading ? handleClick : undefined}
      onMouseOver={onMouseEnter}
      onMouseEnter={onMouseEnter}
      className={classnames('e-select__tray__option', {
        'e-select__tray__option--focus': focus,
        'e-select__tray__option--no-value': option.value === undefined,
        'e-select__tray__option--selected': option.selected,
        'e-select__tray__option--disabled': option.disabled,
        'e-select__tray__option--with-checkbox': withCheckbox
      })}
      data-mu-test={`select__option ${option.value}`}
      data-mu-option-index={optionIndex}
    >
      {withCheckbox && option.value !== undefined && (
        <span className='e-select__tray__option__checkbox'>
          <Checkbox
            disabled={option.disabled}
            checked={option.selected}
            className='e-select__tray__option__checkbox__box'
            value={option.value}
            onChange={handleClick}
          />
        </span>
      )}
      {option.value ? makeLabel(option.label, searchString) : option.label}
    </li>
  )
}

SelectOption.defaultProps = {
  focus: false,
  withCheckbox: false,
  loading: false
}

SelectOption.propTypes = {
  option: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    disabled: PropTypes.bool,
    selected: PropTypes.bool
  }),
  optionIndex: PropTypes.number,
  onMouseEnter: PropTypes.func,
  onSelect: PropTypes.func,
  focus: PropTypes.bool,
  withCheckbox: PropTypes.bool,
  searchString: PropTypes.string,
  loading: PropTypes.bool
}

export const MemoSelectOption = React.memo(
  SelectOption,
  (prevProps, nextProps) => {
    return JSON.stringify(prevProps) === JSON.stringify(nextProps)
  }
)
